export default __webpack_public_path__ + "static/media/bg-2.8b53afe0.jpg";